module.exports = __webpack_public_path__ + "img/EtikettHeight.c820e8c2.png";